<template>
  <div style="height: 100%;width: 100%;overflow: auto">
    <div>
      <el-form ref="formData" :model="busData" label-width="120px" :rules="rules" style="margin: 5px">
        <el-row>
          <el-col :span="11">
            <el-form-item label="登录账号:" prop="user_name" required>
              <el-input v-model="busData.user_name" placeholder="请填写登录账号" clearable disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="姓名:" prop="full_name" required>
              <el-input v-model="busData.full_name" placeholder="请填写姓名" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="电子邮箱:" prop="email" required>
              <el-input v-model="busData.email" placeholder="请填写电子邮箱" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="手机:" prop="mobile">
              <el-input v-model="busData.mobile" placeholder="请填写手机" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="职位:" prop="position_id">
              <el-input v-model="busData.position_id" placeholder="请填写职位" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="部门负责人:" prop="is_head">
              <el-select v-model="busData.is_head" placeholder="确认是否是部门负责人" required>
                <el-option v-for="item in isHeadList" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-col :span="22">
          <el-form-item label="角色" prop="role_ids">
            <el-select v-model="busData.role_ids" placeholder="请选择角色" multiple required clearable>
              <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="部门" prop="department_ids" required>
            <el-cascader v-model="busData.department_ids" placeholder="请选择部门" :options="departmentList" :show-all-levels="false"
                         :props="{ value: 'id',label: 'name',multiple: true,checkStrictly: true,emitPath:false}" style="width: 100%"
                         clearable filterable>
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="用户状态:" >
            <el-select v-model="busData.status" required disabled >
              <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="照片:" >
            <kf-image-upload v-model:init-file="busData.photoFile"  @fileChange="setPhotoId" :limit="1" ></kf-image-upload>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
    <div style="text-align: center;">
        <el-button size="default" type="primary" @click="editUser()">保存</el-button>
        <el-button size="default" type="warning" :disabled = "busData.status === 'user_status_disable'" @click="disableUser()">禁用</el-button>
        <el-button size="default" type="warning" :disabled = "busData.status === 'user_status_active'" @click="enableUser()">解除禁用</el-button>
        <el-button size="default" type="warning" @click="changePassword()">更改密码</el-button>
    </div>
    <el-dialog title="重置密码" v-model="dialogChangePassword" width="50%" center>
      <el-form :model="formData" label-width="120px">
        <el-col :span="22">
          <el-form-item label="登录账号:" disabled>
            <el-input v-model="formData.user_name" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="姓名:" disabled>
            <el-input v-model="formData.full_name" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="密码:" required>
            <el-input v-model="formData.password1" placeholder="请填写密码" clearable show-password></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="确认密码:" required>
            <el-input v-model="formData.password2" placeholder="请填写确认密码" clearable show-password></el-input>
          </el-form-item>
        </el-col>
        <div style="text-align: center;">
          <el-button size="default" type="primary" @click="savePassword()">重置密码</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>


export default {
  name: "UserEdit",
  components: {},
  inject: ['$fn'],

  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  data(){
    return {
      busData: {
        photoFile: [],
      },
      formData: {
        id: '',
        user_name: '',
        full_name: '',
        password1: '',
        password2: '',
      },
      dialogChangePassword: false,
      roleList: [],
      departmentList: [],
      rules: {
        user_name: [
          { required: true, message: '请填写登录账号', trigger: 'change' }
        ],
        full_name: [
          { required: true, message: '请填写姓名', trigger: 'change' }
        ],
        email: [
          { required: true, message: '请填写电子邮箱', trigger: 'change' }
        ],
        role_ids: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ],
        department_ids: [
          { required: true, message: '请选择部门', trigger: 'change'}
        ],
        is_head: [
          { required: true, message: '请确认是否是部门负责人', trigger: 'change' }
        ],
        departmentIds: [
          { required: true, message: '请选择部门', trigger: 'change' }
        ]
      }
    }
  },

  computed: {
    isHeadList() {
      return this.$store.getters['core/getDictList']('bool');
    },
    statusList() {
      return this.$store.getters['core/getDictList']('user_status');
    }
  },

  created() {
    this.getData();
    this.getRoleList();
    this.getDepartmentList();
  },

  methods: {
    async getData() {
      if (this.parentData.head_id) {
        let params = {id: this.parentData.head_id}
        this.busData = await this.$http('sysOrganizationService.getUserData', params);
        return;
      }
      let params = {id: this.parentData.id}
      this.busData = await this.$http('sysOrganizationService.getUserData', params);
    },

    async getRoleList() {
      this.roleList = await this.$http('sysOrganizationService.getRoleList')
    },

    async getDepartmentList() {
      this.departmentList = await this.$http('sysOrganizationService.getDepartmentData')
    },

    async editUser(){
      this.$refs.formData.validate(async valid => {
        if (valid) {
          let params = this.busData;
          this.$http('sysOrganizationService.editUser', params).then(() => {
            this.$message.success("保存成功");
            this.$fn.reloadTreeData();
            this.$fn.closeWindow();
          });
        } else {
          // 表单验证失败，提示用户
          console.log('表单验证失败，请检查输入');
          return false;
        }
      })
    },

    async disableUser(){
      let params = {id: this.busData.id}
      this.$http('sysOrganizationService.disableUser', params).then(() => {
        this.$message.success("禁用成功");
        this.getData();
        this.$fn.reloadTreeData();
      });
    },

    async enableUser(){
      let params = {id: this.busData.id}
      this.$http('sysOrganizationService.enableUser', params).then(() => {
        this.$message.success("解除禁用成功");
        this.getData();
        this.$fn.reloadTreeData();
      });
    },

    setPhotoId(ids){
      if(ids.length>0){
        console.log(ids)
        this.busData.photo=ids
      }else{
        console.log("22222")
        this.busData.photo=''
      }
    },

    changePassword() {
      this.dialogChangePassword = true;
      this.formData.user_name = this.busData.user_name;
      this.formData.full_name = this.busData.full_name;
      this.formData.id = this.busData.id;
    },

    savePassword(){
      if (this.formData.password1 === ''){
        this.$message.error("请填写密码");
      }
      if (this.formData.password2 === ''){
        this.$message.error("请填写确认密码");
      }
      if (this.formData.password1 !== this.formData.password2){
        this.$message.error("两次密码不一致");
      }
      let params = this.formData;
      this.$http('sysUserService.resetPassword', params).then(() => {
        this.$message.success("保存成功");
        this.dialogChangePassword = false;
      });
    }
  },

  beforeUnmount() {
    // 当组件卸载时执行的方法
    this.$fn.reloadTreeData();
  }
}

</script>

<style scoped>

</style>